'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialiseAddressLookup = exports.clearAddress = exports.setView = exports.lookupAddress = undefined;
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _constants = require('../constants');
var _updateFields = require('./update-fields');
var _fieldInfo = require('../selectors/field-info');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var lookupAddress = exports.lookupAddress = function lookupAddress(formId, data, validate, name) {
  return function (dispatch, getState) {
    if (data.Type === 'Address') {
      dispatchRetrieve();
    } else {
      dispatchFind();
    }
    function dispatchFind() {
      var searchText = data.searchText || ((data.buildingNameNumber || '') + ' ' + (data.postcode || '')).trim();
      dispatch({
        type: _constants.actionTypes.ADDRESS_LOOKUP,
        payload: _axios2.default.get(_constants.addressLookupUrls.find, {
          params: {
            Text: searchText,
            Container: data.Id
          }
        }).then(function (response) {
          var items = response.data.Items;
          if (!items || !items.length || 'Error' in items[0]) {
            window.dataLayer.push({
              event: 'aa_lookup',
              aa: {
                lookup_name: 'postcode',
                lookup_result: 'failure',
                error_message: 'not found'
              }
            });
            return []; // empty array leads to manual view
          }
          return items.map(function (item) {
            return Object.assign({}, item, {
              searchText: searchText
            });
          });
        }, function (error) {
          window.dataLayer.push({
            event: 'aa_lookup',
            aa: {
              lookup_name: 'postcode',
              lookup_result: 'failure',
              error_message: error.message
            }
          });
          throw error;
        }),
        meta: {
          formId: formId,
          name: name
        }
      });
    }
    function dispatchRetrieve() {
      dispatch({
        type: _constants.actionTypes.ADDRESS_RETRIEVE,
        payload: _axios2.default.get(_constants.addressLookupUrls.retrieve, {
          params: {
            Id: data.Id
          }
        }).then(function (response) {
          var _setValues;
          var address = response.data.Items[0];
          if ('Error' in address) {
            window.dataLayer.push({
              event: 'aa_lookup',
              aa: {
                lookup_name: 'postcode',
                lookup_result: 'failure',
                error_message: 'not found'
              }
            });
            throw new Error('Not found');
          }
          window.dataLayer.push({
            event: 'aa_lookup',
            aa: {
              lookup_name: 'postcode',
              lookup_result: 'success',
              error_message: ''
            }
          });
          dispatch((0, _updateFields.setValues)(formId, (_setValues = {}, _defineProperty(_setValues, name + 'Options', ''), _defineProperty(_setValues, name + 'Line1', [address.Company, address.Line1].filter(function (x) {
            return x;
          }).join(', ')), _defineProperty(_setValues, name + 'Line2', [address.Line2, address.Line3].filter(function (x) {
            return x;
          }).join(', ')), _defineProperty(_setValues, name + 'TownCity', address.City), _defineProperty(_setValues, name + 'County', address.ProvinceName), _defineProperty(_setValues, name + 'Postcode', address.PostalCode.replace(/ /g, '')), _defineProperty(_setValues, name + 'BuildingNameNumber', ''), _setValues)));
        }, function (error) {
          window.dataLayer.push({
            event: 'aa_lookup',
            aa: {
              lookup_name: 'postcode',
              lookup_result: 'failure',
              error_message: error.message
            }
          });
          throw error;
        }),
        meta: {
          formId: formId,
          name: name
        }
      });
    }
  };
};
var setView = exports.setView = function setView(formId, name, view) {
  return {
    type: _constants.actionTypes.SET_ADDRESS_VIEW,
    name: name,
    formId: formId,
    view: view
  };
};
var clearAddress = exports.clearAddress = function clearAddress(formId, name) {
  return {
    name: name,
    formId: formId,
    type: _constants.actionTypes.RESET_ADDRESS_LOOKUP
  };
};
var initialiseAddressLookup = exports.initialiseAddressLookup = function initialiseAddressLookup(formId, name, defaultPostcode) {
  return function (dispatch, getState) {
    dispatch({
      name: name,
      formId: formId,
      type: _constants.actionTypes.INITIALISE_ADDRESS_LOOKUP
    });
    if (defaultPostcode && typeof (0, _fieldInfo.getValue)(getState(), formId, name + 'Postcode') === 'undefined') {
      dispatch((0, _updateFields.setValue)(formId, name + 'Postcode', defaultPostcode));
    }
  };
};